<script>
  import TimelineScroller from '../TimelineScroller'
  import TripMap from '../TripMap'
  import TripIntro from './TripIntro.svelte'
  import TripOutro from './TripOutro.svelte'

  export let trip
  $: ({ title, subtitle, zoomOptions, coverImage, waypoints } = trip)
  let heldWaypoint = null, activeWaypoint = null
  let scrollToWaypoint, openActiveWaypoint
  // Have to hack around the scroller threshold because svelte-scroller bases it on window height 🙄
  let scrollY, windowHeight, scrollerHeight
  $: scrollerThreshold = Math.max((windowHeight - scrollerHeight*0.7)/windowHeight, 0.3)
  $: scrollerStartThreshold = scrollerThreshold * windowHeight * 0.2 // magic number

  const onWaypointMarkerClicked = (waypoint) => {
    if (waypoint !== activeWaypoint) {
      onWaypointActivated(waypoint)
      scrollToWaypoint(waypoint)
    }
  }

  $: if (heldWaypoint && scrollY >= scrollerStartThreshold) onWaypointActivated(heldWaypoint)
  $: if (activeWaypoint && scrollY < scrollerStartThreshold) onWaypointActivated(activeWaypoint)

  const onWaypointActivated = waypoint => {
    if (scrollY >= scrollerStartThreshold) {
      activeWaypoint = waypoint
      heldWaypoint = null
    }
    else {
      heldWaypoint = waypoint
      activeWaypoint = null

    }
  }
</script>

<svelte:window bind:innerHeight={windowHeight} bind:scrollY />
<div class='scroller-page'>
  <div class='map-wrapper'>
    <TripMap
      {waypoints}
      {activeWaypoint}
      maxZoom={zoomOptions?.maxZoom}
      minZoom={zoomOptions?.minZoom}
      naturalZoom={zoomOptions?.naturalZoom}
      on:waypoint-marker-click={({detail: wp}) => onWaypointMarkerClicked(wp)}
      on:entry-marker-click={({detail: entry}) => onWaypointMarkerClicked(entry.waypoint)}
    />
  </div>
  <div class='timeline-wrapper' bind:offsetHeight={scrollerHeight} >
    <TripIntro {title} {subtitle} {coverImage} />
    <TimelineScroller
      {waypoints}
      {activeWaypoint}
      threshold={scrollerThreshold}
      on:waypoint-activated={({detail}) => onWaypointActivated(detail.waypoint)}
      bind:scrollToWaypoint
      bind:openActiveWaypoint
    />
    <TripOutro />
  </div>
</div>

<style>
  .scroller-page {
    --timeline-proportion: max(50ch, 50%);
    --map-proportion: calc(100% - var(--timeline-proportion));

    position: relative;
    width: 100%;
    height: 100%;
    background: var(--bg-color-accent)
  }

  .map-wrapper {
    z-index: 10; /* Hack to allow timeline to scroll behind map; may cause issues */
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: var(--map-proportion);
  }

  .timeline-wrapper {
    --timeline-inline-spacer: var(--spacer-lg);

    z-index: 1; /* Hack to allow timeline to scroll behind map; may cause issues */
    position: relative;
    left: var(--map-proportion);
    height: 100%;
    width: var(--timeline-proportion);
  }

  @media (max-width: 120ch) {
    .scroller-page {
      --map-proportion: max(30vh, 20ch);
      --timeline-proportion: calc(100% - var(--map-proportion));
    }

    .map-wrapper {
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      bottom: var(--map-proportion);
      height: var(--map-proportion);
    }

    .timeline-wrapper {
      left: 0;
      right: 0;
      width: 100%;
      top: var(--map-proportion);
      height: var(--timeline-proportion);
    }
  }
</style>
